import { Tag, TagColor } from '@equip.health/ui';
import { ConsentToRecord } from '../../lib/constants/patients.constants';

export const getConsentToRecordOptions = (id: string) => {
  return [
    {
      label: (
        <Tag
          color={TagColor.green}
          id={`${id}__consent-given`}
          value={ConsentToRecord.ConsentGiven}
        />
      ),
      value: ConsentToRecord.ConsentGiven,
    },
    {
      label: (
        <Tag
          color={TagColor.red}
          id={`${id}__consent-not-given`}
          value={ConsentToRecord.ConsentNotGiven}
        />
      ),
      value: ConsentToRecord.ConsentNotGiven,
    },
  ];
};

export const getConsentText = (value: boolean | null) => {
  if (value == null) return null;
  return value ? ConsentToRecord.ConsentGiven : ConsentToRecord.ConsentNotGiven;
};

const DAY_OF_WEEK_INDEX: Record<string, number> = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};

export const getNextOccurrenceDate = (
  dayOfWeek: string,
  baseDate = new Date(),
): Date => {
  const targetDay = DAY_OF_WEEK_INDEX[dayOfWeek];
  if (targetDay === undefined) return baseDate;

  const daysUntil = (targetDay - baseDate.getDay() + 7) % 7 || 7;
  const result = new Date(baseDate);
  result.setDate(baseDate.getDate() + daysUntil);
  return result;
};

export const stringifyValue = (
  value: unknown,
  separator: string = ', ',
  fallback: string = '',
): string => {
  if (Array.isArray(value)) {
    return value
      .filter((v): v is string => typeof v === 'string')
      .join(separator);
  }
  return typeof value === 'string' ? value : fallback;
};
